import { UniqueIdentifier } from '@dnd-kit/core';
import { AnimateLayoutChanges, useSortable, defaultAnimateLayoutChanges } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SystemStyleObject } from '@chakra-ui/react';
import GroupContainer, { GroupContainerProps } from 'components/productManager/GroupContainer';
import { specialFont } from 'constants/theme';

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

type DroppableContainerProps = GroupContainerProps & {
  disabled?: boolean;
  id: UniqueIdentifier;
  items: UniqueIdentifier[];
  sx?: SystemStyleObject;
};

const DroppableContainer = ({ children, columns = 1, disabled, id, items, sx, ...props }: DroppableContainerProps) => {
  const { active, attributes, isDragging, listeners, over, setNodeRef, transition, transform } = useSortable({
    id,
    data: {
      type: 'container',
      children: items,
    },
    animateLayoutChanges,
  });
  const isOverContainer =
    over && ((id === over.id && active?.data.current?.type !== 'container') || items.includes(over.id));

  return (
    <GroupContainer
      sx={{
        ...sx,
        transition,
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0.5 : undefined,
        fontFamily: specialFont,
        letterSpacing: 3,
      }}
      ref={disabled ? undefined : setNodeRef}
      hover={isOverContainer as boolean}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      columns={columns}
      {...props}
    >
      {children}
    </GroupContainer>
  );
};

export default DroppableContainer;
